<script>
import getOptionsString from '@/util/getOptionsString'

import Enemy from '../objects/Enemy'
import Item from '../objects/Item'
import Node from '../objects/Node'
import NodePath from '../objects/NodePath'

export default {

  components: {
    Enemy,
    Item,
    Node,
    NodePath
  },

  props: {
    level: {
      type: Object,
      required: true
    }
  },

  computed: {

    uncollectedItems () {
      return this.$store.getters.uncollectedItems
    },

    geometryOptions () {
      return getOptionsString({
        primitive: 'box',
        width: this.level.maxX + 1,
        height: this.level.maxY + 1,
        depth: 1
      })
    }

  }

}
</script>

<template>
  <a-entity
    :geometry="geometryOptions"
    material="visible: false"
    class="c-level-map"
  >

    <!-- Enemies -->
    <template v-for="{ id, nodeId, type } in level.enemies">
      <enemy
        :key="'enemy-' + id"
        :position="[
          level.nodes[nodeId].renderedX,
          level.nodes[nodeId].renderedY,
          level.nodes[nodeId].renderedZ
        ].join(' ')"
        :type="type"
        rotation="90 0 0"
      />
    </template>

    <!-- Items -->
    <template v-for="{ id, nodeId, type } in uncollectedItems">
      <item
        :key="'item-' + id"
        :position="[
          level.nodes[nodeId].renderedX,
          level.nodes[nodeId].renderedY,
          level.nodes[nodeId].renderedZ
        ].join(' ')"
        :type="type"
        rotation="90 0 0"
      />
    </template>

    <!-- Nodes -->
    <template v-for="node in level.nodes">
      <node
        :key="'node-' + node.id"
        :position="[
          node.renderedX,
          node.renderedY,
          node.renderedZ
        ].join(' ')"
        :node="node"
      />
    </template>

    <!-- Paths -->
    <template v-for="{ id, sourceNodeId, targetNodeId } in level.paths">
      <node-path
        :key="'path-' + id"
        :source-node="level.nodes[sourceNodeId]"
        :target-node="level.nodes[targetNodeId]"
      />
    </template>

  </a-entity>
</template>
